<template>
  <div id="container">
    <div class="box-add-message" v-if="isHaveCustomerData" @click="onCustomerCall">
      <div class="el-icon-circle-plus-outline"></div>
      <div>调入客户信息</div>
    </div>
    <!---------- 客户数据 ------------>
    <customer-module
      :customer-data="customerParams"
      v-if="!isHaveCustomerData"
      @changeCustomer="onCustomerCall"
      :isShowChange="$route.query.id?false:true"
      :isShowTransfer="true"
    ></customer-module>
    <div v-show="!isShow">
      <!---------- 物流信息 ------------>
      <logistics-information
        ref="logisticsRefs"
        @changeLogic="changeLogic"
        :signState="1"
        :isContract="params.isContract"
        :isQuotation="isQuotation"
        :orderContractLogistic="params.orderLogistic"
      ></logistics-information>
      <div class="box-table">
        <el-row :gutter="30" class="box-operation">
          <el-col :span="16">
            <el-button @click="onProductSelection" type="primary" plain :disabled="disabledAll">产品选型</el-button>
            <el-button @click="onFoldQuotation" type="primary" plain :disabled="disabledAll">调入报价单</el-button>
            <el-button @click="onFoldContract" type="primary" plain :disabled="disabledAll">调入合同</el-button>
            <el-button @click="leadInProduct" type="primary" plain :disabled="disabledAll">导入表格</el-button>
          </el-col>
          <el-col :span="8" style="text-align:right;">
            <el-button @click="onDelete" type="primary" plain :disabled="disabledAll">移除产品</el-button>
            <el-button
              @click="onBulkEditDeliveryTime"
              type="primary"
              plain
              :disabled="disabledAll"
            >批量修改货期</el-button>
          </el-col>
        </el-row>
        <div style="margin-top:20px;">
          <el-table
            v-compatibleTableWidth
            :data="list"
            max-height="414"
            :row-class-name="tableRowClassName"
            :header-cell-style="tableHeader"
            @selection-change="handleSelectionChange"
            v-loading="loadingTable"
            element-loading-text="拼命加载中请稍后..."
            element-loading-spinner="el-icon-loading"
            border
          >
            <el-table-column fixed type="selection" width="35"></el-table-column>
            <el-table-column min-width="100" label="型号" show-overflow-tooltip fixed>
              <template slot-scope="scope">
                <div
                  class="approval line-limit-length"
                  @click="onProductDetail(scope.row)"
                >{{scope.row.proType}}</div>
              </template>
            </el-table-column>
            <el-table-column label="期望货期" min-width="110" fixed>
              <template slot-scope="scope">
                <el-row :gutter="5">
                  <el-col :span="20">
                    <el-input
                      oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
                      v-model.number="scope.row.ocExtime"
                      :disabled="disabledAll"
                      label="请输入期望货期"
                      @change="onOcExtime(true,scope.$index)"
                    ></el-input>
                  </el-col>
                  <el-col :span="4">天</el-col>
                </el-row>
              </template>
            </el-table-column>
            <el-table-column label="数量" min-width="110" fixed>
              <template slot-scope="scope">
                <el-input-number
                  :precision="0"
                  :min="1"
                  style="width: 100%;"
                  v-model="scope.row.ocNeednumber"
                  @change="ocNeednumberChange(scope.$index)"
                  :disabled="disabledAll"
                  :controls="false"
                ></el-input-number>
              </template>
            </el-table-column>
            <el-table-column label="销售单价" min-width="120" fixed>
              <template slot-scope="scope">
                <span v-if="disabledAll">{{scope.row.ocPrice|priceFilter}}</span>
                <el-input-number
                  v-else
                  :precision="2"
                  :min="0"
                  style="width: 100%;"
                  :controls="false"
                  v-model="scope.row.ocPrice"
                  @change="onInputPrice(scope.row)"
                  :disabled="disabledAll"
                ></el-input-number>
              </template>
            </el-table-column>
            <el-table-column label="折扣" width="110" fixed>
              <template slot-scope="scope">
                <span v-if="disabledAll">{{scope.row.ocDiscount?scope.row.ocDiscount+'%':''}}</span>
                <el-row v-else>
                  <el-col :span="20">
                    <el-input-number
                      :controls="false"
                      style="width: 100%;"
                      :min="0"
                      :precision="2"
                      v-model="scope.row.ocDiscount"
                      @change="onInputDiscount(scope.row)"
                      :disabled="disabledAll"
                    ></el-input-number>
                  </el-col>
                  <el-col :span="4">%</el-col>
                </el-row>
              </template>
            </el-table-column>
            <el-table-column width="80" label="其它方案">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.otherOptions==='选择'"
                  type="text"
                  @click="onSelect(scope.row)"
                >选择</el-button>
              </template>
            </el-table-column>
            <el-table-column prop="brandName" min-width="90" label="品牌" show-overflow-tooltip></el-table-column>
            <el-table-column prop="seriesName" min-width="90" label="系列" show-overflow-tooltip></el-table-column>
            <el-table-column prop="proName" min-width="120" label="产品名称" show-overflow-tooltip></el-table-column>
            <el-table-column prop="orderNumber" min-width="110" label="订货号" show-overflow-tooltip></el-table-column>
            <el-table-column prop="ocUnit" label="单位"></el-table-column>
            <el-table-column min-width="100" label="毛利率">
              <template slot-scope="scope">{{scope.row.ocRate | perCentFilter}}</template>
            </el-table-column>
            <el-table-column min-width="90" label="历史单价">
              <template slot-scope="scope">
                <span v-if="scope.row.ocHistoryPrice">
                  <i
                    @click="fuzi(scope.row,scope.$index,scope.row.ocPrice)"
                    class="iconfont icon-fuzhi"
                  ></i>
                  {{ scope.row.ocHistoryPrice | priceFilter }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="ocUnitPrice" min-width="90" label="供货单价">
              <template slot-scope="scope">{{ scope.row.ocUnitPrice | priceFilter }}</template>
            </el-table-column>
            <el-table-column width="110" label="供货价有效期">
              <template slot-scope="scope">{{scope.row.ocUnitDate | dateFilterD}}</template>
            </el-table-column>
            <el-table-column prop="mark" label="备注" min-width="130" show-overflow-tooltip></el-table-column>
            <el-table-column prop="ocFacePrice" label="面价" min-width="90">
              <template slot-scope="scope">{{ scope.row.ocFacePrice | priceFilter }}</template>
            </el-table-column>
            <el-table-column label="询价来源">
              <template
                slot-scope="scope"
              >{{ ocPriceSourceFormart(scope.row.ocPriceSource) || '--' }}</template>
            </el-table-column>
          </el-table>
        </div>
        <h4>总计</h4>
        <el-table
          v-compatibleTableWidth
          :data="totalList"
          border
          :header-cell-style="tableHeader"
          v-loading="loadingTotalTable"
          element-loading-text="拼命加载中请稍后..."
          element-loading-spinner="el-icon-loading"
        >
          <el-table-column prop="orderKind" label="产品种类"></el-table-column>
          <el-table-column label="销售总额">
            <template slot-scope="scope">{{ scope.row.orderTotal | priceFilter }}</template>
          </el-table-column>
          <el-table-column label="供货总额">
            <template slot-scope="scope">{{ scope.row.orderCost | priceFilter }}</template>
          </el-table-column>
          <el-table-column label="毛利率">
            <template slot-scope="scope">{{ scope.row.orderRate | perCentFilter }}</template>
          </el-table-column>
        </el-table>
        <el-row :gutter="30">
          <el-col :span="24" style="text-align:right;margin-top:20px;">
            <el-button
              :disabled="isQuotation || disabledAll || isBut"
              @click="onRequestSystemQuotation"
              type="primary"
            >请求系统报价</el-button>
            <el-button
              :disabled="isHandle || isQuotation||disabledAll|| isBut"
              @click="onAddByOrderId"
              type="primary"
            >请求人工报价</el-button>
            <el-button
              :disabled="isHandle || isQuotation||disabledAll"
              @click="onSpecialOfferApproval"
              type="primary"
            >特价审批</el-button>
            <el-button
              :disabled="isHandle || isQuotation||disabledAll||list.length===0"
              @click="onCreateQuotation"
              type="primary"
            >生成报价单</el-button>
            <el-button type="primary" @click="onBatchOut" :disabled="!isQuotation||isExport">导出报价单</el-button>
            <el-button
              :disabled="!isQuotation || disabledAll || isBut"
              @click="onGenerateContract"
              type="primary"
            >生成合同</el-button>
          </el-col>
        </el-row>
      </div>
      <!-------------- 工单日志 -------------->
      <load-operation-log title="工单日志" v-if="$route.query.id"></load-operation-log>
    </div>
    <!-------------- 调入客户信息 ------------>
    <customer-call-dialog ref="customerCallDialogRefs" @onRefresh="addJoinCustomer"></customer-call-dialog>
    <!-------------- 产品选型 -------------->
    <product-selection
      ref="productSelectionRefs"
      :tableList="list"
      @onMyEnquiry="onMyEnquiry"
      v-show="isShow"
      orderType="我的询价单"
    ></product-selection>
    <!-------------- 调入报价单 -------------->
    <fold-quotation-dialog
      titleQuotationList="调入报价单"
      @onTransferInQuotation="onTransferInSubmit"
      ref="foldQuotationDialogRefs"
    ></fold-quotation-dialog>
    <!-------------- 调入合同 -------------->
    <transfer-in-contract-dialog @onTransferInContract="onTransferInSubmit" ref="transferRefs"></transfer-in-contract-dialog>
    <!-------------- 批量修改货期 -------------->
    <bulk-edit-delivery-time-dialog
      ref="bulkEditDeliveryTimeDialogRefs"
      :checkList="checkList"
      @onUpdateDate="onUpdateDate"
    ></bulk-edit-delivery-time-dialog>
    <!-------------- 生成报价单 弹窗 -------------->
    <open-or-close
      ref="OpenOrCloseRefs"
      title="提示"
      content="确认生成报价单？"
      @onUpdataState="onUpdataState"
    ></open-or-close>
    <!-------------- 特价审批 -------------->
    <special-offer-approval-dialog ref="specialOfferApprovalDialogRefs"></special-offer-approval-dialog>
    <!-------------- 导入表格 -------------->
    <lead-in @onRefresh="onRefresh" ref="batchInRefs"></lead-in>
    <!-------------- 选择方案 -------------->
    <program-dialog ref="programDialogRefs" @onSubmit="init"></program-dialog>
    <download-file-dialog ref="downloadFileDialogRefs"></download-file-dialog>
  </div>
</template>
<script>
import leadIn from '@/components/leadIn/batchIn' // 导入
import loadOperationLog from '@/components/OperationLog/loadOperationLog' // 工单日志
import foldQuotationDialog from '../dialog/foldQuotationDialog' // 调入报价单
import bulkEditDeliveryTimeDialog from './dialog/bulkEditDeliveryTimeDialog' // 批量修改货期
import customerCallDialog from '../dialog/customerCallDialog' // 调入客户信息
import OpenOrClose from '@/components/OpenOrClose/index'
import specialOfferApprovalDialog from './dialog/specialOfferApprovalDialog' // 特价审批
import productSelection from '@/components/ProductSelections/productSelection' // 产品选型
import customerModule from '@/components/checkLayout/module/customerModule' // 客户信息
import logisticsInformation from './components/quiry/logisticsInformation' // 物流信息
import transferInContractDialog from './dialog/transferInContractDialog' // 调入合同
import programDialog from './dialog/programDialog' // 选择方案
import downloadFileDialog from './dialog/downloadFileDialog' // 导出弹窗
import {
  orderContractBaseQueryByBase,
  addByOrderId,
  orderContentAddByOrderId,
  orderContentDelete,
  orderBaseAdd,
  orderBaseQueryById
} from '@/api/sell/sellManage'
import { queryCustomerCreditById } from '@/api/customer/customerManage'
export default {
  components: {
    downloadFileDialog,
    'lead-in': leadIn,
    'program-dialog': programDialog,
    'load-operation-log': loadOperationLog,
    'fold-quotation-dialog': foldQuotationDialog,
    'bulk-edit-delivery-time-dialog': bulkEditDeliveryTimeDialog,
    'customer-call-dialog': customerCallDialog,
    'open-or-close': OpenOrClose,
    'special-offer-approval-dialog': specialOfferApprovalDialog,
    'product-selection': productSelection,
    'customer-module': customerModule,
    'logistics-information': logisticsInformation,
    'transfer-in-contract-dialog': transferInContractDialog
  },
  data() {
    return {
      checkList: [], // 列表选中的数据
      loadingTable: false, // 列表loading加载
      loadingTotalTable: false, // 总计列表loading加载
      list: [], // 列表数据
      totalList: [], // 总计列表数据
      tempList: [], // 需要提交的 临时列表文件
      isShow: false, // 是否显示产品选型
      isHaveCustomerData: true, // 是否有客户数据
      customerParams: {}, // 客户数据
      isHandle: true, // 是否可以点击(人工系统报价)=====判断是详情页或新建页面
      isQuotation: false, // 是否可以点击(生成报价单)
      isExport: false, // 生成合同   导出按钮
      params: {}, // 接收请求系统报价后的数据
      disabledAll: false, // 审核中按钮禁用状态
      isBut: false
    }
  },
  watch: {
    '$route.name'(val) {
      if (val === 'sellInquiryDetails') {
        this.init()
      } else {
        this.list = []
        this.isHaveCustomerData = true
        this.isHandle = true
        this.isQuotation = false
        this.disabledAll = false
        this.isShow = false
        this.params = {}
        this.customerParams = {}
        this.$refs.logisticsRefs.queryParams = { logicType: '快递配送' }
      }
    },
    list: {
      handler(val) {
        if (val) {
          const obj = {
            orderTotal: 0,
            orderCost: 0,
            orderRate: 0,
            orderKind: val.length
          }
          val.forEach((ele) => {
            if (ele.ocPrice) {
              ele.ocTotal = (+ele.ocNeednumber * +ele.ocPrice).toFixed(2)
              obj.orderTotal += +ele.ocTotal
            }
            if (ele.ocUnitPrice) {
              ele.ocUnitTotal = (+ele.ocNeednumber * +ele.ocUnitPrice).toFixed(2)
              obj.orderCost += +ele.ocUnitTotal
            }
          })
          if (obj.orderCost) {
            obj.orderRate = ((obj.orderTotal - obj.orderCost) / obj.orderCost).toFixed(4)
          }
          this.totalList = [obj]
        }
      },
      deep: true
    }
  },
  methods: {
    resetData(row) {
      // 重置数据
      const obj = {
        brandId: row.brandId, // 品牌id
        brandName: row.brandName, // 品牌名称
        ocExtime: +row.ocExtime, // 货期周期
        ocFacePrice: row.ocFacePrice, // 面价
        ocNeednumber: +row.ocNeednumber, // 需求数量
        orderNumber: row.orderNumber, // 订货号
        proId: row.proId, // 产品id
        proName: row.proName, // 产品名称
        proType: row.proType, // 产品型号
        seriesId: row.seriesId, // 系列id
        seriesName: row.seriesName, // 系列名称
        ocPrice: row.ocPrice,
        ocDiscount: row.ocDiscount,
        isSuccess: 97,
        ocUnit: row.ocUnit // 产品单位
      }
      return obj
    },
    onSelect(row) {
      // 选择方案弹窗
      this.$refs.programDialogRefs.init(row)
    },
    onBatchOut() {
      // 导出报价单
      this.$refs.downloadFileDialogRefs.onInitial(this.list)
    },
    onRefresh(list) {
      // 导入报价单
      list.forEach((ele) => {
        ele.brandId = ele.bbId // 品牌id
        ele.seriesId = ele.bsId // 系列id
        ele.ocExtime = +ele.extimeValue // 货期周期
        ele.ocFacePrice = ele.productPrice // 面价
        ele.ocNeednumber = ele.count // 需求数量
        ele.proName = ele.productName // 产品名称
        ele.proType = ele.productModel // 产品型号
        ele.ocUnit = ele.proUnit // 产品单位
      })
      this.onTransferInSubmit(list)
    },
    leadInProduct() {
      // 导入表格
      this.$refs.batchInRefs.onLeadIn(this.$store.state.sellGuidIn, '销售-询价导入表格')
    },
    onOcExtime(F, index) {
      // 修改货期类型合并
      if (F) {
        this.list[index] = this.resetData(this.list[index])
        if (this.params.isQuotation === 1) {
          this.isQuotation = false
          this.isHandle = false
        }
      }
      const arr = this.list.reduce((obj, item) => {
        const find = obj.find((i) => i.proId === item.proId && +i.ocExtime === +item.ocExtime)
        const _d = item
        find ? (find.ocNeednumber += item.ocNeednumber) : obj.push(_d)
        return obj
      }, [])
      arr.forEach((ele, i) => {
        if (
          arr.some(
            (m) =>
              m.proId === ele.proId &&
              +m.ocExtime === +ele.ocExtime &&
              m.ocNeednumber !== ele.ocNeednumber
          )
        ) {
          this.list[i] = this.resetData(this.list[i])
        }
      })
      this.list = JSON.parse(JSON.stringify(arr))
    },
    // 批量修改货期
    onBulkEditDeliveryTime() {
      if (this.checkList.length > 0) {
        this.$refs.bulkEditDeliveryTimeDialogRefs.onInitial()
      } else {
        this.$message.error('请选择需要修改货期的产品')
      }
    },
    // 确认修改货期
    onUpdateDate(val) {
      console.log('批量修改货期', val)
      this.checkList.forEach((ele) => {
        if (+ele.ocExtime !== +val) {
          ele.isSuccess = 97
          ele.ocUnitPrice = 0
          ele.ocPriceSource = ''
          ele.mark = ''
          ele.ocUnitDate = ''
          if (this.params.isQuotation === 1) {
            this.isQuotation = false
            this.isHandle = false
          }
        }
        ele.ocExtime = +val
      })
      this.onOcExtime()
    },
    onProductDetail(row) {
      this.$router.push({ name: 'productDetails', query: { id: row.proId } })
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.isSuccess === 97) {
        return 'warning-row'
      }
    },
    fuzi(row, i, num) {
      if (+row.ocPrice !== +row.ocHistoryPrice) {
        row.ocPrice = row.ocHistoryPrice
        this.onInputPrice(row)
      }
    },
    onCustomerCall() {
      this.$refs.customerCallDialogRefs.onInitial()
    },
    changeLogic() {
      // 已生成报价单改变物流信息 更改按钮的禁用状态
      this.isQuotation = false
      this.isHandle = false
    },
    // 调入客户信息后回调
    addJoinCustomer(params) {
      this.isHaveCustomerData = false
      this.$nextTick(() => {
        this.customerParams = params // 接收客户信息
      })
    },
    ocNeednumberChange(i) {
      this.list.splice(i, 1, this.resetData(this.list[i]))
      if (this.params.isQuotation === 1 && this.list.some((ele) => !ele.ocUnitPrice)) {
        this.isQuotation = false
        this.isHandle = false
      }
    },
    // 产品选型
    onProductSelection() {
      this.isShow = true
      this.$refs.productSelectionRefs.getOnInitial() // 点击产品选型初始化
    },
    // 调入报价单
    onFoldQuotation() {
      this.$refs.foldQuotationDialogRefs.onInitial()
    },
    // 调入合同
    onFoldContract() {
      this.$refs.transferRefs.onInitial()
    },
    // 确定调入报价单/合同后回调
    onTransferInSubmit(data) {
      let isMsg = false
      data.forEach((item) => {
        let isBool = false
        // 由于后端调入询价单的时候返回了报价信息,产品要求不需要显示报价信息,所以需要前端处理有些字段不显示
        // delete item.ocPrice
        // delete item.ocDiscount
        item.ocDiscount = item.ocDiscount * 100
        const params = this.resetData(item)
        let index = null
        this.list.forEach((ele, i) => {
          if (ele.proId === params.proId && +ele.ocExtime === +params.ocExtime) {
            isMsg = true
            isBool = true
            params.ocNeednumber += ele.ocNeednumber
            params.ocPrice = item.ocPrice
            params.ocDiscount = item.ocDiscount
            index = i
          }
        })
        if (isBool) {
          this.list[index] = params
        } else {
          this.list.push(params)
        }
      })
      this.list = JSON.parse(JSON.stringify(this.list))
      if (isMsg) {
        this.$message.success('已有相同产品，数量已合并')
      }
      if (this.params.isQuotation === 1 && this.list.some((ele) => !ele.ocUnitPrice)) {
        this.isQuotation = false
        this.isHandle = false
      }
    },
    // 生成报价单
    onCreateQuotation() {
      if (this.list.length === 0) {
        this.$message.error('请选择询价产品')
        return
      }
      const mess1 = false
      let mess2 = false
      let mess3 = false
      this.tempList = JSON.parse(JSON.stringify(this.list))
      this.tempList.forEach((item) => {
        // if (!item.ocUnitPrice) {
        //   mess1 = true
        // } else
        if (item.ocPrice === undefined || !+item.ocNeednumber) {
          mess2 = true
        } else if (new Date().getTime() > item.ocUnitDate) {
          mess3 = true
        }
        item.ocDiscount = +item.ocDiscount / 100
      })
      if (mess1) {
        this.$message.error('请求失败，产品列表中存在无报价产品！')
        return
      }
      if (mess2) {
        this.$message.error('请求失败，产品列表中存在无单品报价产品！')
        return
      }
      if (mess3) {
        this.$message.error('请求失败，产品列表中存在已过期产品，请重新询价！')
        return
      }
      this.$refs.OpenOrCloseRefs.onInitial()
    },
    // 生成报价单确认审批
    onUpdataState() {
      const params = {
        ...this.params,
        ...this.totalList[0],
        starPoint: this.customerParams.starPoint,
        cusId: this.customerParams.id,
        orderContentStorageVoList: this.tempList,
        orderLogistic: this.$refs.logisticsRefs.queryParams // 物流
      }
      orderBaseAdd(params).then((res) => {
        if (res.data.code === 200) {
          this.params = res.data.obj
          this.$message.success('已成功生成报价单！')
          this.isQuotation = true
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 生成合同
    onGenerateContract() {
      this.isBut = true
      orderContractBaseQueryByBase(this.$route.query.id).then((res) => {
        if (res.data.code === 200) {
          if (res.data.obj.id) {
            this.$router.push({
              name: 'contractCreate',
              query: { id: res.data.obj.id }
            })
          } else {
            this.$message.error('生成合同失败')
          }
        } else {
          this.$message.error(res.data.msg)
        }
        this.isBut = false
      })
    },
    // 特价审批
    onSpecialOfferApproval() {
      if (this.checkList.length > 0) {
        let isObId = false
        let isBall = false
        let isOcExtime = false
        this.checkList.forEach((item) => {
          if (!item.obId) {
            isObId = true
          } else if (!item.ocExtime) {
            isOcExtime = true
          } else if (!item.ocUnitPrice) {
            isBall = true
          }
        })
        if (isObId) {
          this.$message.error('存在数据没有完成系统报价，请重新选择！')
        } else if (isBall) {
          this.$message.error('请求失败，所选产品中存在无报价产品！')
        } else if (isOcExtime) {
          this.$message.error('请选择期望货期！')
        } else {
          this.$refs.specialOfferApprovalDialogRefs.onInitial(this.checkList)
        }
      } else {
        this.$message.error('请选择要请求特价审批的产品！')
      }
    },
    // 列表数据选中
    handleSelectionChange(row) {
      this.checkList = row
    },
    // 设置头部背景色
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 返回我的询价单
    onMyEnquiry(val) {
      val.forEach((item) => {
        let isBool = false
        this.list.forEach((ele, index) => {
          if (ele.proId === item.proId && +ele.ocExtime === +item.ocExtime) {
            isBool = true
            if (ele.ocNeednumber !== item.ocNeednumber) {
              this.list.splice(index, 1, this.resetData(item))
            }
          }
        })
        if (!isBool) {
          this.list.push(item)
        }
      })
      if (this.params.isQuotation === 1 && this.list.some((ele) => !ele.ocUnitPrice)) {
        this.isQuotation = false
        this.isHandle = false
      }
      this.isShow = false
    },
    // 改变单品报价时计算折扣
    onInputPrice(row) {
      if (this.params.isQuotation === 1) {
        this.isQuotation = false
        this.isHandle = false
      }
      // 毛利率
      row.ocRate =
         +row.ocUnitPrice
           ? (((+row.ocPrice || 0) - +row.ocUnitPrice) / +row.ocUnitPrice).toFixed(4)
           : null
      // 折扣
      row.ocDiscount =
        +row.ocFacePrice
          ? ((+row.ocPrice / +row.ocFacePrice) * 100).toFixed(2)
          : null
    },
    // 改变折扣时计算单品报价
    onInputDiscount(row) {
      if (this.params.isQuotation === 1) {
        this.isQuotation = false
        this.isHandle = false
      }
      row.ocPrice =
        +row.ocFacePrice && +row.ocDiscount
          ? ((+row.ocDiscount / 100) * +row.ocFacePrice).toFixed(2)
          : null
      row.ocRate =
         +row.ocUnitPrice
           ? ((+row.ocPrice - +row.ocUnitPrice) / +row.ocUnitPrice).toFixed(4)
           : null
    },
    // 移除产品
    onDelete() {
      if (this.checkList.length > 0) {
        const list = []
        this.checkList.forEach((ele) => {
          if (ele.ocId) {
            list.push({
              obId: ele.obId,
              proId: ele.proId,
              ocId: ele.id
            })
          } else {
            const index = this.list.findIndex(
              (m) => m.proId === ele.proId && +m.ocExtime === +ele.ocExtime
            )
            this.list.splice(index, 1)
          }
        })
        if (list.length > 0) {
          orderContentDelete(list).then((res) => {
            if (res.data.code === 200) {
              list.forEach((ele) => {
                const index = this.list.findIndex((m) => m.ocId === ele.ocId)
                this.list.splice(index, 1)
              })
              this.$message.success('移除成功')
              if (this.params.isQuotation === 1) {
                this.isQuotation = false
                this.isHandle = false
              }
            } else {
              this.$message.error(res.data.msg)
            }
          })
        }
      } else {
        this.$message.error('请选择需要移除的产品！')
      }
    },
    // 请求系统报价
    onRequestSystemQuotation() {
      if (this.list.length === 0) {
        this.$message.error('请选择询价产品！')
        return
      }
      if (this.list.some((ele) => !ele.ocNeednumber)) {
        this.$message.error('请填写询价数量！')
        return
      }
      if (this.list.some((ele) => !ele.ocExtime)) {
        this.$message.error('期望货期不得为空！')
        return
      }
      if (this.customerParams.id) {
        this.tempList = JSON.parse(JSON.stringify(this.list))
        this.tempList.forEach((ele) => {
          ele.ocDiscount = +ele.ocDiscount / 100
        })
        const params = {
          id: this.$route.query.id || null,
          cusId: this.customerParams.id,
          orderContentStorageVoList: this.tempList,
          orderLogistic: this.$refs.logisticsRefs.queryParams
        }
        this.isBut = true
        addByOrderId(params).then((res) => {
          if (res.data.code === 200) {
            this.isBut = false
            if (res.data.obj.flag === false) {
              const str = this.list.some((m) => m.otherOptions === '选择')
                ? '有产品暂无报价，可选择其他方案！'
                : '有产品暂无报价，请请求人工询价！'
              this.$message.error(str)
            } else {
              this.$message.success('请求系统报价成功')
            }
            if (this.$route.name !== 'sellInquiryDetails') {
              this.$router.push({
                name: 'sellInquiryDetails',
                query: { id: res.data.obj.id }
              })
            } else {
              const tableList = res.data.obj.orderContentStorageVoList
              tableList.forEach((m) => {
                m.isSuccess = !m.ocUnitPrice ? 97 : 85
                m.ocRate = (m.ocRate || 0).toFixed(4)
                m.ocDiscount = m.ocPrice ? ((+m.ocPrice / +m.ocFacePrice) * 100).toFixed(2) : null
              })
              this.list = this.list.map(item => {
                const index = tableList.findIndex(tableItem => {
                  return tableItem.proId === item.proId && tableItem.ocExtime == item.ocExtime
                })
                if (index !== -1) return tableList[index]
                return item
              })
              console.log(this.list)
            }
          } else {
            this.$message.error(res.data.msg)
          }
        })
      } else {
        this.$message.error('请先调入客户信息！')
      }
    },
    // 请求人工报价
    onAddByOrderId() {
      if (this.checkList.length > 0) {
        if (this.checkList.every((m) => m.obId)) {
          this.isBut = true
          const params = {
            cusId: this.customerParams.id,
            orderContentStorageVoList: this.checkList,
            orderLogistic: this.$refs.logisticsRefs.queryParams
          }
          orderContentAddByOrderId(this.customerParams.id, params).then((res) => {
            if (res.data.code === 200) {
              this.$message.success('请求人工报价成功！')
              this.init()
            } else {
              this.$message.error(res.data.msg)
            }
          })
        } else {
          this.$message.error('存在数据没有完成系统报价，请重新选择！')
        }
      } else {
        this.$message.error('请选择要请求人工报价的产品！')
      }
    },
    init() {
      this.isHandle = false
      this.isHaveCustomerData = false
      orderBaseQueryById(this.$route.query.id).then((res) => {
        this.params = res.data.obj
        if (this.params.orderState === 1 || this.params.isQuotation === 2) {
          this.disabledAll = true // 审批状态 所有按钮禁用
          this.isExport = true
        }
        if (this.params.isContract === 1) {
          this.disabledAll = true
          this.isExport = false
        }
        this.isQuotation = this.params.isQuotation === 1
        this.list = JSON.parse(JSON.stringify(this.params.orderContentList))
        this.list.forEach((m) => {
          m.ocRate = (m.ocRate || 0).toFixed(4)
          m.cusId = this.params.cusId
          m.isSuccess = !m.ocUnitDate ? 97 : 85
          m.ocDiscount = m.ocPrice ? ((+m.ocPrice / +m.ocFacePrice) * 100).toFixed(2) : null
        })
        queryCustomerCreditById(this.params.cusId).then((rel) => {
          this.customerParams = rel.data.obj
        })
      })
    },
    ocPriceSourceFormart(val) {
      const map = new Map([
        [1, '系统'], [2, '人工'], [3, '特价审批'], [4, '其他'], [5, '库存']
      ])
      return map.get(val)
    }
  },
  created() {
    if (this.$route.query.id) {
      this.init()
    }
  }
}
</script>
